



























import { CabinetConfigurationModel, CabinetReferenceConfigurationModel, CabinetReferenceType } from '@/types';
import { CabinetSummaryOptions } from '@/types/enums/configuration/cabinet/CabinetSummaryOptions';
import Vue from 'vue';

export default Vue.extend({
  name: 'CabinetSummaryInfoAlert',
  data() {
    return {
      cabinetSummaryOptions: CabinetSummaryOptions
    };
  },
  props: {
    cabinetConfiguration: {
      type: Object as () => CabinetConfigurationModel,
      required: true
    },
    cabinetSummaryOptionsDisplayed: {
      type: Array as () => CabinetSummaryOptions[],
      required: true
    }
  },
  computed: {
    documentTypeCount(this: any) {
      return this.cabinetConfiguration.documentTypes?.length ?? 0;
    },
    cabinetReferenceCount(this: any) {
      return this.cabinetConfiguration.cabinetReferences
        ?.filter((cr: CabinetReferenceConfigurationModel) => 
          !cr.isDeleted && cr.referenceType === CabinetReferenceType.Common)
        .length ?? 0;
    }
  },
  methods: {
    showSummaryOption(this: any, option: CabinetSummaryOptions) {
      return this.cabinetSummaryOptionsDisplayed.some((o: CabinetSummaryOptions) => o === option);
    }
  }
});
